import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { NavigationUi, NavigationUi$ } from '@app/constants';
import { MetaService } from '@app/data';


@Injectable({
  providedIn: 'root'
})
export class ScreenService {

  private _activeItem$ = new BehaviorSubject<any>([{}]);
  public activeItem$ = this._activeItem$.pipe(/*skip(1)*/);
  public activeScreen$ = new BehaviorSubject<any[]>([]);
	public showPlayBtn$ = new BehaviorSubject<boolean>(false);
  public next$ = new BehaviorSubject<any>(false);
  public prev$ = new BehaviorSubject<any>(false);
  
	constructor(
    private meta: MetaService
	) {}

	public getNavigationUi$ = (): NavigationUi$ => {
    return {next$: this.next$, prev$: this.prev$};
  };

  public getActiveItem = (): any => this._activeItem$.value;

	public hideScreen = () => {
	  console.log('ScreenService hideScreen this ', this);

    this.showPlayBtn$.next(false);
    this.activeScreen$.next([]);
	}

	/* SCREEN STORE */

	public setScreenStore = (input: any): void => {
    console.log('ScreenService setScreenStore input ', input);

    this._activeItem$.next([input.activeItem]);
    this.prev$.next(input.prev);
    this.next$.next(input.next);

    if (input.activeItem.entityBundle === 'no-image' || input.activeItem.entityBundle === 'about' || !input.activeItem) {
      return;
    }

    this.meta.setMetaTags(input.activeItem);
    this.showPlayBtn$.next(input.showPlayBtn);
    this.activeScreen$.next([input.activeItem]);
  }
}
